import { Flexbox } from "st-app";
import { GroupAction } from "./GroupAction";
import { Group } from "./Group";

import styles from '../sis-role-dashboard.module.css'
import { UserSuggestions } from "./UserSuggestions";
import { UserRecentHistory } from "./UserRecentHistory";
import { For, createMemo } from "solid-js";
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import { StaffRole } from "../../../api/SISApp";

export function AttendanceClerkDashboard() {
    const ctx = requireRoleDashboardContext();

    const tasks = ctx.sortedActions([
        'AttClerk.CheckIn',
        'AttClerk.VerifyAbsence',
        'AttClerk.AttActivity',
        'K12.LocateStudent',
    ]);

    const shortcuts = createMemo(() => {
        const addShortcuts = ctx.configuration()
            ?.additionalShortcuts
            .filter(desc => desc.role === StaffRole.AttendanceClerk)
            .map(desc => desc.ID!);

        return ctx.sortedActions([
            'K12.PersonSearch',
            'AttClerk.AttLetters',
            'AttClerk.DailyAtt',
            'AttClerk.PeriodAtt',
            'AttClerk.ClassDailyAtt',
            'AttClerk.MassChangeAtt',
            'AttClerk.ReviewParentAtt',
            'AttClerk.ClassroomTakenAtt',
        ].concat(addShortcuts ?? []));
    });

    return <Flexbox dir="horizontal" auto class={styles['dashboard-content']} >
        <Flexbox dir="vertical" auto>
            <Group title="Tasks" icon="fas fa-graduation-cap" color="--header-green">
                <For each={tasks}>{id => <GroupAction id={id} />}</For>
            </Group>

            <Group title="Shortcuts" icon="fas fa-info-circle" color="--header-blue">
                <For each={shortcuts()}>{id => <GroupAction id={id} allowDetach />}</For>
            </Group>

            <UserSuggestions />

            <Flexbox.Item auto />
        </Flexbox>

        <UserRecentHistory />
    </Flexbox>
}

